(function () {
  'use strict';

  var owner = document.getElementById('pb-clarity-consent');
  if (!owner || owner.getAttribute('data-initialized') === 'true') return;
  var project = owner.getAttribute('data-project-id');
  if (!project || !/^[a-z0-9]+$/i.test(project)) return;
  if (document.querySelector('script[src*="clarity.ms/tag/"]')) return;
  owner.setAttribute('data-initialized', 'true');

  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  var previous = '';
  var timer = null;
  var attempts = 0;
  var requested = false;
  var paused = false;

  function signal(marketing, analytics) {
    var ad = marketing === true ? 'granted' : 'denied';
    var measurement = analytics === true ? 'granted' : 'denied';
    var state = ad + ':' + measurement;
    if (state === previous) return;
    window.clarity('consentv2', { ad_Storage: ad, analytics_Storage: measurement });
    previous = state;
    owner.setAttribute('data-consent-state', state);
  }

  function clearRetry() {
    if (timer !== null) window.clearTimeout(timer);
    timer = null;
  }

  function readPrivacy() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' ||
        typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    try {
      var marketing = privacy.marketingAllowed();
      var analytics = privacy.analyticsProcessingAllowed();
      if (typeof marketing !== 'boolean' || typeof analytics !== 'boolean') return false;
      signal(marketing, analytics);
      clearRetry();
      return true;
    } catch (error) {
      return false;
    }
  }

  function scheduleRetry() {
    if (paused || timer !== null || attempts >= 10) return;
    attempts += 1;
    timer = window.setTimeout(function () {
      timer = null;
      check();
    }, 500);
  }

  function check() {
    if (paused || readPrivacy()) return;
    if (!requested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      requested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          if (!paused && !readPrivacy()) scheduleRetry();
        });
      } catch (error) {
        scheduleRetry();
      }
    }
    scheduleRetry();
  }

  signal(false, false);
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail;
    if (detail && typeof detail.marketingAllowed === 'boolean' &&
        typeof detail.analyticsAllowed === 'boolean') {
      clearRetry();
      signal(detail.marketingAllowed, detail.analyticsAllowed);
    } else if (!readPrivacy()) {
      signal(false, false);
    }
  });
  window.addEventListener('pagehide', function () {
    paused = true;
    clearRetry();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    paused = false;
    attempts = 0;
    check();
  });
  check();

  var tag = document.createElement('script');
  tag.async = true;
  tag.src = 'https://www.clarity.ms/tag/' + project;
  document.head.appendChild(tag);
})();
